var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/RemoveDependencyDialog.tsx";
import "core-js/modules/es.function.name.js";
import * as React from 'react';
import { Button, Toolbar, IconButton } from '@mui/material';
import styled from 'styled-components';
import { Close } from '@mui/icons-material';
import { Home, Checkup, CubeWithTarget, CalculateIcon } from '@gmini/ui-kit';
import { Box } from '@gmini/ui-kit/lib/Box';
import { DialogContent as DialogContentInit } from '@gmini/ui-kit/lib/DialogContent';
import { DialogActions } from '@gmini/ui-kit/lib/DialogActions';
import { Dialog } from '@gmini/ui-kit/lib/Dialog';
import { DialogTitle } from '@gmini/ui-kit/lib/DialogTitle';
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { CubeWithTargetWrapper } from "./DependencyTree/nodes/AssemblyClassifierNodeContent.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RemoveDependencyDialog = /*#__PURE__*/React.memo(function (_ref) {
  var name = _ref.name,
      type = _ref.type,
      onClose = _ref.onClose,
      removeDependency = _ref.removeDependency;

  var entityName = function entityName(type) {
    switch (type) {
      case 'BaseClassifierNode':
      case 'BimModelNode':
      case 'BimFileTreeNode':
      case 'ForgeModel':
        return 'модель';

      case 'UserClassifierNode':
        return 'классификатор';

      case 'AssemblyClassifierNode':
      case 'AssemblyModel':
        return 'сборку';

      default:
        return '';
    }
  };

  var getIcon = function getIcon(type) {
    if (type === 'UserClassifierNode') {
      return /*#__PURE__*/_jsx(Checkup, {
        fontSize: "large"
      });
    }

    if (type === 'AssemblyModel' || type === 'AssemblyClassifierNode') {
      return /*#__PURE__*/_jsx(CubeWithTargetWrapper, {
        children: /*#__PURE__*/_jsx(CubeWithTarget, {})
      });
    }

    if (type === 'AnonymousClassifierNode') {
      return /*#__PURE__*/_jsx(CalculateIcon, {});
    }

    return /*#__PURE__*/_jsx(Home, {
      fontSize: "large"
    });
  };

  return /*#__PURE__*/_jsxs(Dialog, {
    open: true,
    maxWidth: "sm",
    fullWidth: true,
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(DialogTitle, {
      children: /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsxs(Toolbar, {
          disableGutters: true,
          variant: "dense",
          children: [/*#__PURE__*/_jsx(Box, {
            flexGrow: 1,
            children: " \u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u044C"
          }), /*#__PURE__*/_jsx(IconButton, {
            "data-test-id": "close",
            onClick: onClose,
            size: "large",
            children: /*#__PURE__*/_jsx(Close, {
              fontSize: "small"
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsxs(DialogContent, {
      dividers: true,
      children: [/*#__PURE__*/_jsxs(QuestionText, {
        color: "textSecondary",
        children: ["\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C ", entityName(type), " ?"]
      }), /*#__PURE__*/_jsxs(StatusPanelLayout, {
        children: [/*#__PURE__*/_jsx(IconWrap, {
          children: getIcon(type)
        }), /*#__PURE__*/_jsx(DependencyName, {
          align: "inherit",
          children: name
        })]
      }), /*#__PURE__*/_jsx(Typography, {
        color: "error",
        variant: "caption",
        children: "\u0411\u0443\u0434\u0443\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0432\u0441\u0435 \u0440\u0430\u0437\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u044D\u0442\u043E\u0439 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438"
      })]
    }), /*#__PURE__*/_jsxs(DialogActions, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "cancel",
        variant: "contained",
        onClick: onClose,
        children: "\u041E\u0442\u043C\u0435\u043D\u0430"
      }), /*#__PURE__*/_jsx(DangerButton, {
        "data-test-id": "confirm",
        onClick: removeDependency,
        variant: "contained",
        autoFocus: true,
        children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"
      })]
    })]
  });
});
RemoveDependencyDialog.displayName = 'RemoveDependencyDialog';
export var StatusPanelLayout = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '20px'
});
export var DangerButton = styled(Button)({
  color: '#fff',
  backgroundColor: '#f44336',
  '&:hover': {
    backgroundColor: '#d32f2f'
  }
});
var IconWrap = styled('div')({
  marginRight: '10px',
  display: 'flex',
  alignItems: 'center'
});
var DependencyName = styled(Typography)({
  fontSize: '18px',
  color: '#1B2B4B'
});
var QuestionText = styled(Typography)({
  fontSize: '14px',
  marginBottom: '20px'
});
var DialogContent = styled(DialogContentInit)({
  padding: '36px 24px'
});